import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function DermaplaningWaxingHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-969">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/3zeyCCQrgrmTTDFpKCRAs8/dermaplaning-.jpg)'
    }} data-id="element-970" />
      <div className="absolute inset-0 bg-black/50" data-id="element-971" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-972">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-973">
          <div className="mb-6" data-id="element-974">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-975">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-976">
                Treatments
              </a>{' '}
              / Skin
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-977">
            Be CLEVER
          </span>

          <h1 className="text-[32px] sm:text-4xl lg:text-[56px] uppercase text-white tracking-tight mb-6 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-978">
            DERMAPLANING & WAXING
          </h1>

          <div className="space-y-6" data-id="element-979">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-980">
              <em data-id="element-981">
                "Stop wasting time plucking away facial hair with tweezers or
                trying at-home dermaplaning kits that don't deliver the same
                results—and can even be risky without the right technique,"
              </em>{' '}
              says Dr. Fiona Frie.{' '}
              <em data-id="element-982">
                "Why not get pampered at Be CLINICAL, where you can have a
                professional create that silky, smooth finish safely and
                effectively?"
              </em>
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-983">
              Take care of facial hair in one session of dermaplaning or waxing
              at Be CLINICAL, giving you that flawless skin and a fresh start
              for your beauty routine.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-984">
              <em data-id="element-985">
                "Waxing is such an easy way to keep skin looking polished and
                flawless, and both treatments are quick, effective ways to keep
                your beauty routine streamlined. It's an easy way to invest in
                yourself!"
              </em>
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-986">
              At Be CLINICAL, esthetician services like dermaplaning and waxing
              are popular choices for clients seeking a smooth, flawless
              complexion!
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-987">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}